import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import logo from '../images/askme.png';
import NavMenu from './NavMenu';
import ThemeSwitcher from './utilities/ThemeSwitcher';
import Button from './utilities/Button';

export default function Header() {
  const { pathname } = useLocation();
  const isLoginRegsiter = pathname === '/login' || pathname === '/register';
  const { authUser = null } = useSelector((state) => state);
  const navigate = useNavigate();
  const goToHome = () => navigate('/');
  const goToLogin = () => navigate('/login');
  const goToRegister = () => navigate('/register');

  return (
    <header className="w-full fixed top-0 flex justify-between gap-x-4 lg:gap-x-10 items-center h-[60px] md:h-[80px] px-4 md:px-20 max-w-screen-xl mx-auto z-30 border-b dark:border-zinc-50/20 bg-white dark:bg-zinc-800">
      <button type="button" onClick={goToHome}>
        <img src={logo} alt="askme" height="77" width="128" />
      </button>
      <div className="flex gap-x-4 lg:gap-x-12 items-center">
        {authUser ? (
          <NavMenu />
        ) : (
          <div className="flex gap-x-4 items-center">
            {!isLoginRegsiter && (
              <>
                <Button
                  label="Register"
                  variant="tertiary"
                  className="hidden md:flex"
                  onClick={goToRegister}
                />
                <Button label="Login" onClick={goToLogin} />
              </>
            )}
          </div>
        )}
        <ThemeSwitcher />
      </div>
    </header>
  );
}
